@if (isLoading()) {
<sura-mobility-loader />
} @else {
<banner-app
  [Fixtop]="''"
  [retroSelected]="false"
  [infoDueno]="false"
  [showPromo]="true"
></banner-app>
<div class="Padre">
  <div class="container my-4">
    @if (invoices().length === 0) {
    <div class="text-center mb-4">
      <img
        src="./assets/img/FeedBackManos.png"
        class="image"
        alt="seguro de moto precio"
        loading="lazy"
      />
      <h1 class="mb-0">¡Estás al día!</h1>
      <h5 class="subtitle my-3 mt-lg-5">No tienes pagos pendientes.</h5>
      <button
        class="btn btn-primary localButton backStartButton mt-3"
        (click)="volverIncio()"
        type="submit"
      >
        <strong>Entendido</strong>
      </button>
    </div>
    } @else {
    <h1>{{ accountName() }}, estas son tus facturas pendientes:</h1>

    <sura-pending-invoices-subscription
      [(isSubscriptionActive)]="subscriptionActive"
      [isDisabled]="isSubscriptionDisabled()"
    >
    </sura-pending-invoices-subscription>

    @if (showAnnualAlert()) {
    <div class="annual-alert" role="alert">
      <div class="annual-alert__icon" aria-hidden="true"></div>
      <div class="annual-alert__content">
        <strong class="annual-alert__title">No puedes activar el débito automático</strong>
        <p class="annual-alert__body">Este pago es anual. El débito automático solo aplica para pagos mensuales.</p>
      </div>
      <button type="button" class="annual-alert__close" (click)="dismissAnnualAlert()" aria-label="Cerrar alerta">&#x2715;</button>
    </div>
    }

    <div class="insurances-container">
      @for (insurance of invoices(); track insurance.id) {
      <sura-pending-invoices-card
        [cardData]="insurance"
        [isChecked]="selectedCard()?.id === insurance.id"
        [isPaymentProcessing]="isPaying()"
        (cardSelected)="handleCardSelection($event)"
        (paymentRequested)="handlePayment($event)"
      >
      </sura-pending-invoices-card>
      }
    </div>
    }
  </div>
  <app-footer-app class="footer-fixed" />
</div>
}
